"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.statefulFunction = exports.min = exports.minAsync = exports.max = exports.maxAsync = exports.count = exports.countAsync = exports.ZERO = exports.addOne = exports.yieldEmpty = exports.yieldAsyncEither = exports.yieldObjAsync = exports.yieldObj = exports.asyncFilterUnique = exports.asyncIterConcat2 = exports.asyncIterConcat = exports.asyncIterTap = exports.asyncIterAny = exports.asyncIterReduce = exports.asyncIterEitherFilter = exports.asyncIterRaiseEither = exports.asyncIterFilter = exports.asyncIterFlatMap = exports.asyncIterStatefulMap = exports.asyncIterMap = exports.asyncEitherIterFlatMap = exports.asyncEitherIterMap = exports.asyncIterHandler = exports.toAsyncIterableIterator = exports.iterCollect = exports.filterUnique = exports.iterConcat = exports.iterIncludes = exports.iterFind = exports.iterReduce = exports.iterFilter = exports.iterMap = exports.iterToArray = exports.iterFromArray = void 0;
const api_1 = require("../typings/api");
const AsyncEither_1 = require("./AsyncEither");
const Either_1 = require("./Either");
const Util_1 = require("./Util");
function* iterFromArray(array) {
    for (const i of array) {
        yield i;
    }
}
exports.iterFromArray = iterFromArray;
function iterToArray(iter) {
    const result = [];
    for (const i of iter) {
        result.push(i);
    }
    return result;
}
exports.iterToArray = iterToArray;
const iterMap = (map) => function* (iter) {
    for (const i of iter) {
        yield map(i);
    }
};
exports.iterMap = iterMap;
function iterFilter(filter) {
    return function* (iter) {
        for (const i of iter) {
            if (filter(i)) {
                yield i;
            }
        }
    };
}
exports.iterFilter = iterFilter;
const iterReduce = (reducer) => (initialValue) => (iter) => {
    let value = initialValue;
    for (const i of iter) {
        value = reducer(value, i);
    }
    return value;
};
exports.iterReduce = iterReduce;
function iterFind(predicate) {
    return (iter) => {
        for (const i of iter) {
            if (predicate(i)) {
                return i;
            }
        }
    };
}
exports.iterFind = iterFind;
const iterIncludes = (value) => (iter) => {
    for (const i of iter) {
        if (value === i) {
            return true;
        }
    }
    return false;
};
exports.iterIncludes = iterIncludes;
const iterConcat = (iter1) => function* (iter2) {
    for (const item of iter1) {
        yield item;
    }
    for (const item of iter2) {
        yield item;
    }
};
exports.iterConcat = iterConcat;
const filterUnique = function* (iter) {
    const found = {};
    for (const item of iter) {
        if ('id' in item) {
            const item2 = item;
            if (!found[item2.id]) {
                found[item2.id] = true;
                yield item;
            }
        }
        else {
            if (!found[item.toString()]) {
                found[item.toString()] = true;
                yield item;
            }
        }
    }
};
exports.filterUnique = filterUnique;
const iterCollect = (iter1) => {
    const results = [];
    for (const i of iter1) {
        results.push(i);
    }
    return results;
};
exports.iterCollect = iterCollect;
async function* toAsyncIterableIterator(iter) {
    for await (const i of iter) {
        yield i;
    }
}
exports.toAsyncIterableIterator = toAsyncIterableIterator;
const asyncIterHandler = (errorHandler) => async function* (iter) {
    const errorIter = {
        async next(...args) {
            try {
                const result = await iter.next(...args);
                if (result.done) {
                    return { done: true, value: Either_1.Either.right(result.value) };
                }
                return { done: false, value: Either_1.Either.right(result.value) };
            }
            catch (e) {
                return { done: false, value: Either_1.Either.left(errorHandler(e)) };
            }
        },
    };
    for await (const i of { [Symbol.asyncIterator]: () => errorIter }) {
        yield i;
    }
};
exports.asyncIterHandler = asyncIterHandler;
const asyncEitherIterMap = (map) => async function* (iter) {
    for await (const i of iter) {
        if (i.direction === 'left') {
            yield i;
        }
        else {
            yield Either_1.Either.right(await map(i.value));
        }
    }
};
exports.asyncEitherIterMap = asyncEitherIterMap;
const asyncEitherIterFlatMap = (map) => async function* (iter) {
    for await (const i of iter) {
        if (i.direction === 'left') {
            yield i;
        }
        else {
            yield AsyncEither_1.asyncEither(i, api_1.errorGenerator('Wat')).flatMap(map);
        }
    }
};
exports.asyncEitherIterFlatMap = asyncEitherIterFlatMap;
const asyncIterMap = (map) => async function* (iter) {
    for await (const i of iter) {
        yield map(i);
    }
};
exports.asyncIterMap = asyncIterMap;
const asyncIterStatefulMap = (initialState) => (map) => (iter) => {
    let res;
    let rej;
    return [
        new Promise((resolve, reject) => {
            res = resolve;
            rej = reject;
        }),
        (async function* () {
            let state = typeof initialState === 'object' ? { ...initialState } : initialState;
            let yieldValue;
            try {
                for await (const i of iter) {
                    const mapObj = map(i, state);
                    if (mapObj instanceof AsyncEither_1.AsyncEither) {
                        [state, yieldValue] = await mapObj.fullJoin();
                    }
                    else {
                        [state, yieldValue] = await mapObj;
                    }
                    yield yieldValue;
                }
            }
            catch (e) {
                rej === null || rej === void 0 ? void 0 : rej(e);
            }
            res === null || res === void 0 ? void 0 : res(state);
        })(),
    ];
};
exports.asyncIterStatefulMap = asyncIterStatefulMap;
const asyncIterFlatMap = (map) => async function* (iter) {
    for await (const i of iter) {
        for await (const j of i) {
            yield map(j);
        }
    }
};
exports.asyncIterFlatMap = asyncIterFlatMap;
function asyncIterFilter(filter) {
    return async function* (iter) {
        for await (const i of iter) {
            if (await filter(i)) {
                yield i;
            }
        }
    };
}
exports.asyncIterFilter = asyncIterFilter;
const asyncIterRaiseEither = (errorValue) => (iter) => {
    const internal = async () => {
        const results = [];
        for await (const i of iter) {
            if (Either_1.Either.isLeft(i)) {
                return i;
            }
            results.push(i.value);
        }
        return Either_1.Either.right(results);
    };
    return AsyncEither_1.asyncRight(internal(), errorValue).flatMap(Util_1.identity);
};
exports.asyncIterRaiseEither = asyncIterRaiseEither;
function asyncIterEitherFilter(filter) {
    return async function* (iter) {
        for await (const i of iter) {
            const res = filter(i).fullJoin().then(Util_1.identity, Util_1.alwaysFalse);
            if (await res) {
                yield i;
            }
        }
    };
}
exports.asyncIterEitherFilter = asyncIterEitherFilter;
const asyncIterReduce = (reducer) => (initialValue) => async (iter) => {
    let value = initialValue;
    for await (const i of iter) {
        value = await reducer(value, i);
    }
    return value;
};
exports.asyncIterReduce = asyncIterReduce;
const asyncIterAny = (predicate) => async (items) => {
    for await (const item of items) {
        if (predicate(item)) {
            return true;
        }
    }
    return false;
};
exports.asyncIterAny = asyncIterAny;
const asyncIterTap = (tapfunction) => async function* (iter) {
    for await (const i of iter) {
        await tapfunction(i);
        yield i;
    }
};
exports.asyncIterTap = asyncIterTap;
const asyncIterConcat = (iter1) => async function* (iter2) {
    for await (const item of iter1) {
        yield item;
    }
    for await (const item of iter2()) {
        yield item;
    }
};
exports.asyncIterConcat = asyncIterConcat;
const asyncIterConcat2 = async function* (...iters) {
    for (const iter of iters) {
        for await (const item of iter) {
            yield item;
        }
    }
};
exports.asyncIterConcat2 = asyncIterConcat2;
const asyncFilterUnique = async function* (iter) {
    const found = {};
    for await (const item of iter) {
        if (typeof item === 'string' || typeof item === 'number') {
            if (!found[item.toString()]) {
                found[item.toString()] = true;
                yield item;
            }
        }
        else {
            if (!(item.id in found)) {
                found[item.id] = true;
                yield item;
            }
        }
    }
};
exports.asyncFilterUnique = asyncFilterUnique;
const yieldObj = function* (item) {
    yield item;
};
exports.yieldObj = yieldObj;
const yieldObjAsync = async function* (item) {
    yield item;
};
exports.yieldObjAsync = yieldObjAsync;
const yieldAsyncEither = async function* (item) {
    yield item;
};
exports.yieldAsyncEither = yieldAsyncEither;
const yieldEmpty = async function* () {
};
exports.yieldEmpty = yieldEmpty;
const addOne = (i) => i + 1;
exports.addOne = addOne;
exports.ZERO = 0;
exports.countAsync = exports.asyncIterReduce(exports.addOne)(exports.ZERO);
exports.count = exports.iterReduce(exports.addOne)(exports.ZERO);
exports.maxAsync = exports.asyncIterReduce(Math.max)(Number.NEGATIVE_INFINITY);
exports.max = exports.iterReduce(Math.max)(Number.NEGATIVE_INFINITY);
exports.minAsync = exports.asyncIterReduce(Math.min)(Number.POSITIVE_INFINITY);
exports.min = exports.iterReduce(Math.min)(Number.POSITIVE_INFINITY);
const statefulFunction = (initialState) => (func) => {
    let state = initialState;
    let returnValue;
    return (val) => {
        [returnValue, state] = func(val, state);
        return returnValue;
    };
};
exports.statefulFunction = statefulFunction;
//# sourceMappingURL=iter.js.map